import { getLocale } from 'jscommon/localeUtil.js';

const SyncAjax = (apiName, options, method, isAsync, successCallback, errorCallback, viewObj) => {
  let tsStr = '',
    headers = {}, locale = getLocale ? getLocale() : '';

  /** 返回值必须检查字段，如果没有刷新页面 */
  const returnRequired = options ? options.returnRequired : '';
  if (options && (typeof options === 'object')) {
    options.isAjax = 1;
    if (options.returnRequired) {
      delete options.returnRequired;
    }
  } else {
    options = {
      isAjax: 1
    };
  }
  const ajaxDataType = options.ajaxDataType || 'json';
  window.tnsSdk.writeXscfToken('YHT')

  if (typeof isAsync == 'function') {
    errorCallback = successCallback;
    successCallback = isAsync;
    isAsync = false;
  }

  if (method == 'GET') {
    if (apiName.indexOf("?") !== -1) {
      tsStr = '&ts=' + (new Date().getTime());
    } else {
      tsStr = '?ts=' + (new Date().getTime());
    }
    tsStr += ('&locale=' + locale);
  } else {
    options.locale = locale;
  }
  if (isAsync !== true) {
    isAsync = false;
  }

  if (options.headers && (options.headers == 'json')) {
    headers = {
      'Content-Type': 'application/json'
    };
    options = JSON.stringify(options);
  } else {
    headers = {
      locale: locale
    };
  }
  $.ajaxSetup({"cache": false})
  $.ajax({
    url: window.yhtUserCenterBaseUrl + apiName + tsStr,
    dataType: ajaxDataType,
    type: method,
    async: isAsync,
    headers: headers,
    data: options,
    xhrFields: {
      withCredentials: true  //解决跨服务传递时不传递cookie的问题，允许携带证书
    },
    beforeSend: function (request) {
      request.setRequestHeader("isAjax", options.isAjax);
      request.setRequestHeader("x-xsrf-token", window.tnsSdk.readXscfToken('YHT'));
      options['access_token'] && request.setRequestHeader("Authorization", 'Bearer ' + options['access_token']);
    },
    success: function (json) {
      // window.console && console.log(json);
      if (json && json.needrelogin) {
        if (process.env.NODE_ENV === 'dev') {
          // 公有云
          window.location.href = 'https://idtest.yyuap.com/cas/login?service=http%3A%2F%2Flocalhost%3A3000%2FproxyDevTicket';
          // window.location.href = 'http://172.20.25.117:8090/cas/login?service=http%3A%2F%2Flocalhost%3A3000%2FproxyDevTicket';
          // 专属云
          // window.location.href = 'http://172.20.25.117:8088/cas/login?service=http%3A%2F%2Flocalhost%3A3000%2FproxyDevTicket';
        } else {
          window.location.reload();
        }

      }
      /** 请求成功后判断必填字段 */
      if ((json.status === 1) && returnRequired && !json[returnRequired]) {
        window.location.reload();
      }
      if (successCallback && (typeof successCallback == 'function')) {
        successCallback.call(viewObj, json);
      }
    }.bind(this),
    error: function (xhr, status, err) {
      if (errorCallback && (typeof errorCallback == 'function')) {
        errorCallback.call(viewObj, xhr, status, err);
      }
    }.bind(this)
  });
}

export const SyncPost = (apiName, options, isAsync, successCallback, errorCallback, viewObj) => {
  if (typeof isAsync == 'function') {
    errorCallback = successCallback;
    successCallback = isAsync;
    isAsync = false;
  }
  SyncAjax(apiName, options, "POST", isAsync, successCallback, errorCallback, viewObj);
}

export const SyncGet = (apiName, options, isAsync, successCallback, errorCallback, viewObj) => {
  if (typeof options == 'boolean') {
    /**apiName, isAsync, successCallback, errorCallback */
    errorCallback = successCallback;
    successCallback = isAsync;
    isAsync = options;
    options = null;
  } else if (typeof options == 'function') {
    /**apiName,successCallback, errorCallback */
    errorCallback = isAsync;
    successCallback = options;
    isAsync = false;
    options = null;
  } else if (typeof isAsync == 'function') {
    /**apiName,options,successCallback, errorCallback */
    errorCallback = successCallback;
    successCallback = isAsync;
    isAsync = false;
  }

  SyncAjax(apiName, options, "GET", isAsync, successCallback, errorCallback, viewObj);
}